import React from "react"
import PropTypes from "prop-types"
import styles from "./MenuItem.module.css"
import { useDispatch, useSelector } from "react-redux"
import { metadataSelector } from "store/selectors"
import classNames from "classnames"
import { useNavigate } from "react-router-dom"
import { Icon } from "ui/Icon"
import { setProHomeMenuClose } from "store/pro-home-menu"

export const MenuItem = ({ item }) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const metaData = useSelector(metadataSelector("conversations"))
  const { guide } = useSelector((state) => state.user)
  const { activeMenu } = useSelector((state) => state.proHomeMenu)
  const { name, id, iconName, iconType, path, openInNewTab } = item
  const isActive = activeMenu === id
  const hasUnviewedMessages = metaData.total_unviewed_messages > 0 && id === "messages"

  const onClickHandler = () => {
    dispatch(setProHomeMenuClose())
    const dynamicPath = typeof path === "string" ? path : path({ slug: guide.slug })
    if (openInNewTab) {
      const base = `${window.location.origin}${window.location.pathname}`
      const normalizedPath = dynamicPath.startsWith("/") ? dynamicPath : `/${dynamicPath}`
      const url = `${base}#${normalizedPath}`
      window.open(url, "_blank", "noopener")
    } else {
      navigate(dynamicPath)
    }
  }

  return (
    <div role="button" className={classNames(styles.menuGroupItem, isActive && styles.menuGroupItemActive)} onClick={onClickHandler}>
      <Icon name={iconName} type={iconType} strokeWidth={1} className={styles.itemIcon} color="currentColor" />
      <div className={styles.itemName}>{name}</div>
      {hasUnviewedMessages && <div className={styles.unviewed}>{metaData.total_unviewed_messages}</div>}
    </div>
  )
}

// Add PropTypes validation
MenuItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    iconName: PropTypes.string.isRequired,
    iconType: PropTypes.string.isRequired,
    path: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
    openInNewTab: PropTypes.bool
  }).isRequired
}
